// There is two image origins: MediaServer and Sitecore. Components will have to set from which origin the image will come
// If not set by default it will generate images for MediaServer
export enum ImageOrigin {
  MediaServer = 'MediaServer',
  CMSSitecore = 'CMSSitecore',
}

export function buildImgSrc(url: string, width: number, height?: number, imageOrigin: ImageOrigin = ImageOrigin.MediaServer, position?: [number, number]): string {
  if (!url) {
    return ''
  }

  const normalizedUrl = url.replace(/^http:\/\//, 'https://')
  if (normalizedUrl.includes('platform195')) {
    return buildImgSrcForPlatform195(normalizedUrl, width, height, position)
  }
  if (imageOrigin === ImageOrigin.CMSSitecore) {
    return buildImgSrcForCMSSitecore(normalizedUrl, width, height, position)
  }
  return buildImgSrcForMediaServer(normalizedUrl, width, height, position)
}

export function buildImgSrcSet(url: string, widths: number[], imageOrigin: ImageOrigin = ImageOrigin.MediaServer) {
  return widths
    .map((width) => {
      return `${buildImgSrc(url, width, undefined, imageOrigin)} ${width}w`
    })
    .join(', ')
}

function buildImgSrcForMediaServer(url: string, width: number, height?: number, position?: [number, number]) {
  if (url.includes('&mode=') || url.includes('&scale='))
    return url

  let fullUrl = `${url}?width=${width}`

  if (height) {
    fullUrl += `&height=${height}`
  }

  if (position) {
    fullUrl += `&pointx=${position[0]}&pointy=${position[1]}`
  }

  return `${fullUrl}&mode=crop&scale=both`
}

function buildImgSrcForCMSSitecore(url: string, width: number, height?: number, position?: [number, number]) {
  let fullUrl = `${url}?dw=${width}`

  if (height) {
    fullUrl += `&dh=${height}`
  }

  if (position) {
    fullUrl += `&pointx=${position[0]}&pointy=${position[1]}`
  }

  return fullUrl
}

function buildImgSrcForPlatform195(url: string, width: number, height?: number, position?: [number, number]) {
  const urlObj = new URL(url)
  urlObj.searchParams.set('w', width.toString())
  if (height) {
    urlObj.searchParams.set('h', height.toString())
  }
  else {
    urlObj.searchParams.delete('h')
  }

  if (position) {
    urlObj.searchParams.set('px', position[0].toString())
    urlObj.searchParams.set('py', position[1].toString())
  }

  return urlObj.toString()
}
